import { z } from 'zod';

/**
 * Канонические коды ошибок API. Источник: `docs/architecture/api-contracts.md` §1.
 * Каждый код привязан к HTTP-статусу — соответствие проверяется CI на бэке.
 */
export const ErrorCodeSchema = z.enum([
  // Validation (HTTP 400)
  'INVALID_INPUT',
  'INVALID_PHONE',
  'INVALID_OTP',
  'INVALID_REGION',
  'CONSENT_REQUIRED',
  'PROMO_NOT_APPLICABLE',
  // Auth (HTTP 401/403/410)
  'UNAUTHORIZED',
  'FORBIDDEN',
  'OTP_EXPIRED',
  'OTP_ATTEMPTS_EXCEEDED',
  'JWT_EXPIRED',
  'JWT_INVALID',
  'REGION_LOCKED',
  // Resources (HTTP 404/409/410)
  'NOT_FOUND',
  'CONFLICT',
  'GONE',
  // Rate / quota (HTTP 429)
  'RATE_LIMITED',
  'QUOTA_EXCEEDED',
  'HARD_CAP_EXCEEDED',
  // Business (HTTP 402/403/409)
  'PAYMENT_FAILED',
  'PROVIDER_UNAVAILABLE',
  'SUBSCRIPTION_REQUIRED',
  'TRIAL_EXPIRED',
  // Server (HTTP 500/503/504)
  'INTERNAL_ERROR',
  'SERVICE_UNAVAILABLE',
  'DEPENDENCY_TIMEOUT',
]);

export type ErrorCode = z.infer<typeof ErrorCodeSchema>;

export const ApiErrorSchema = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;
